function fromBase64(input) {
  try {
    return decodeURIComponent(atob(input));
  } catch (error) {
    console.error('Failed to decode base64 string:', error);
    throw new Error('Invalid base64 encoded parameter');
  }
}

function toBase64(input) {
  try {
    return btoa(encodeURIComponent(input));
  } catch (error) {
    console.error('Failed to encode to base64:', error);
    throw new Error('Failed to encode parameter');
  }
}

export { fromBase64, toBase64 };
